import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  toogleDataCheck,
  fetchOwners,
  setFilterOwner,
} from "../../store/app/DataQualityStatus/DataQualitySlice";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import PropTypes from "prop-types";


const OwnersSelector = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const refreshCount = useSelector(
    (state) => state.dataQualityReducer.refreshCount
  );

  useEffect(() => {
    dispatch(fetchOwners());
  }, [dispatch]);

  useEffect(() => {
    // get parameters from url query
    let value;
    try {
      value = JSON.parse(searchParams.get("owner")) || "";
    } catch (error) {
      value = props.defaultValue || "";
      console.error(error);
    }

    dispatch(setFilterOwner(value));
  }, [navigate, refreshCount]);

  const owners = useSelector((state) => state.dataQualityReducer.owners);

  const stateValue = useSelector(
    (state) => state.dataQualityReducer.filterOwner
  );


  /**
   * Gestisce il cambio selezione
   * @param {*} event
   */
  const handleChange = (event) => {
    dispatch(setFilterOwner(event.target.value?.user_name ?? null));
    dispatch(toogleDataCheck(true));
  };

  /**
   * Render di un elemento
   * @param {*} li
   * @param {*} itemProps  L'elemento da visualizzare
   * @returns
   */
  const itemRender = (li, itemProps) => {
    const itemChildren = (
      <span className="form-check py-1">
        <input
          id={`filter_owner_id_${itemProps.index}`}
          type="checkbox"
          checked={itemProps.selected}
          onChange={() => {}}
          className="form-check-input"
          style={{ pointerEvents: "none" }}
        />
        <label className="form-check-label" style={{ cursor: "pointer" }}>{itemProps.dataItem.user_name}</label>
      </span>
    );
    return React.cloneElement(
      li,
      {
        ...li.props,
        style: { ...li.props.style, transition: "background-color 0.15s ease" },
        onMouseEnter: (e) => (e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.15)"),
        onMouseLeave: (e) => (e.currentTarget.style.backgroundColor = ""),
      },
      itemChildren
    );
  };

  const value = owners?.find((item) => item.user_name === stateValue) ?? null;

  return (
    <DropDownList
      id="ownersSelector"
      className="form-select-kendo"
      data={owners}
      dataItemKey="user_name"
      textField="user_name"
      value={value}
      onChange={handleChange}
      defaultItem={{ user_name: "All" }}
      itemRender={itemRender}
    />
  );
};

OwnersSelector.propTypes = {
  defaultValue: PropTypes.array,
};


export default OwnersSelector;
